import { VERSION_PERIOD_SEARCH_TYPE } from '../../../constants/service/app/versionConstants';

export const VERSION_TYPE_MODEL = {
  /**
   *  타입 ID
   */
  type: 0,
};

export const VERSION_INFO_MODEL = {
  /**
   *  서비스 버전
   */
  serviceVer: null,
  /**
   *  버전 코드
   */
  code: null,
  /**
   *  강제 업데이트 여부
   */
  forceUpdate: 0,
  /**
   *  마일스톤
   */
  milestone: null,
  /**
   *  스프린트
   */
  sprint: null,
  /**
   *  마켓에 등록한 날짜
   */
  marketRegisterDate: null,
  /**
   *  릴리즈 된 날짜
   */
  releaseDate: null,
  /**
   *  Jira 버전 링크 url
   */
  jiraUrl: null,
  /**
   *  메모
   */
  memo: null,
};

/**
 *  버전 상세 모델
 */
export const VERSION_DETAIL_MODEL = {
  /**
   *  상품 ID
   */
  versionId: null,
  /**
   *  타입
   */
  verType: VERSION_TYPE_MODEL,
  /**
   *  버전 정보
   */
  verInfo: VERSION_INFO_MODEL,
};

/**
 *  버전 리스트 검색 옵션 모델
 */
export const VERSION_LIST_SEARCH_OPTION_MODEL = {
  /**
   * 버전 타입
   */
  type: null,
  /**
   *  서비스 버전
   */
  serviceVer: null,
  /**
   *  버전 코드
   */
  code: null,
  /**
   *  강제 업데이트 여부
   */
  forceUpdate: null,
  /**
   *  조회 기간
   */
  viewPeriod: {
    /**
     *  조회 기간 타입
     */
    type: VERSION_PERIOD_SEARCH_TYPE.MARKET_REGISTER_DATE,
    /**
     *  빠른 날짜 선택 값
     */
    quickDateIndex: -1,
    /**
     *  기간
     */
    period: {
      startDate: null,
      endDate: null,
    },
  },
};

/**
 *  버전 전체 리스트 정렬 옵션 모델
 */
export const VERSION_LIST_SORT_OPTION_MODEL = {
  versionId: 'descend',
  // serviceVer: "descend",
  // code: "descend",
  // milestone: "descend",
  // sprint: "descend",
  // createDate: "descend",
  // updateDate: "descend",
};
